/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.consumers
 */
ProductApiConsumerService.$inject = [
    'PRODUCT_API_BASE_URL',
    'ApiConsumerService',
];
function ProductApiConsumerService(
    PRODUCT_API_BASE_URL,
    ApiConsumerService
) {
    return {
        get: get,
        post: post,
        put: put,
        delete: delete_request,
        request: request,
        getFullUrl: getFullUrl
    };

    /**
     * Makes a request (of the given type inside requestData) to the given url of the product api with the given parameters
     * It works as a substitute for $http({'method': 'post', 'url': url, ...}) in the consumer level
     * @return {Promise}
     */
    function request(requestData) {
        requestData.withCredentials = true;
        return ApiConsumerService.request(requestData, PRODUCT_API_BASE_URL);
    }

    /**
     * Makes a get request to the given url of the product api with the given parameters
     *
     * @return {Promise}
     */
    function get(url, config) {
        config = config || {};
        return ApiConsumerService.get(url, config, PRODUCT_API_BASE_URL);
    }

    /**
     * Makes a post request to the given url of the product api with the given data
     *
     * @return {Promise}
     */
    function post(url, data, config) {
        config = config || {};
        return ApiConsumerService.post(url, data, PRODUCT_API_BASE_URL, config);
    }

    /**
     * Makes a put request to the given url of the product api with the given data
     *
     * @return {Promise}
     */
    function put(url, data, config) {
        config = config || {};
        return ApiConsumerService.put(url, data, PRODUCT_API_BASE_URL, config);
    }

    /**
     * Makes a delete request to the given url of the product api with the given data
     *
     * @return {Promise}
     */
    function delete_request(url) {
        return ApiConsumerService.delete(url, PRODUCT_API_BASE_URL);
    }

    /**
     * Gets the full url for the product apis based on the given relative url
     *
     * @param {string} url
     * @returns {string}
     */
    function getFullUrl(url) {
        return ApiConsumerService.getFullUrl(PRODUCT_API_BASE_URL, url);
    }


}

module.exports = ProductApiConsumerService;